import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { adminInquiryListQuerySchema } from "@kansai-ai-hub/schema";

import { AdminInquiryDetailPage } from "@/features/admin/inquiries/inquiry-detail-page";
import { adminInquiryDetailQueryOptions } from "@/features/admin/inquiries/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/inquiries/$id")({
  staticData: { crumb: { label: "詳細" } },
  /**
   * **一覧の検索条件を持ち回るためだけの search。** 詳細画面自体は何も絞り込まない。
   *
   * これが無いと「一覧へ戻る」リンクが毎回タブだけの初期状態に戻り、
   * 検索語・絞り込み・ページ番号が消える。一覧 → 詳細 → 戻る、を繰り返すのが
   * この画面の主な使われ方（03_タスク分解.md 3-7）なので、往復で状態を失わせない。
   *
   * すべて optional にする。詳細を直接 URL で開く導線（メール・ブックマーク）では
   * 何も付かないため、必須にすると弾いてしまう。
   *
   * `page` / `pageSize` は**既定値ごと上書き**して optional にする。`.partial()` は
   * `ZodDefault` を包むだけで既定値の適用までは止められない（zod v4 で実測）ため、
   * そのままだと詳細を直接開いただけで `?page=1&pageSize=20` が URL に付く。
   * 一覧はページ送りをしないので、ここで既定値を持つ意味は無い。
   */
  validateSearch: adminInquiryListQuerySchema
    .omit({ status: true })
    .extend({
      page: z.coerce.number().int().min(1).optional(),
      pageSize: z.coerce.number().int().min(1).max(100).optional(),
    })
    .partial(),
  loader: async ({ context, params }) => {
    await context.queryClient.ensureQueryData(adminInquiryDetailQueryOptions(params.id));
  },
  component: AdminInquiryDetailPage,
});
